import { render, staticRenderFns } from "./MediaPreview.vue?vue&type=template&id=5584d206"
import script from "./MediaPreview.vue?vue&type=script&lang=js"
export * from "./MediaPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports